import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Highlighter from 'react-highlight-words';

const lookups = [
  {
    lookup: 'co2',
    getRange: passage => {
      const start = passage.index + 2;
      const end = passage.index + 3;
      return { start, end };
    },
  },
  {
    lookup: 'plus',
    getRange: passage => {
      const start = passage.index + passage.word.indexOf('plus');
      const end = start + 4;
      return { start, end };
    },
  },
];

const useStyles = makeStyles(() => ({
  italic: {
    fontStyle: 'italic',
  },
  superScript: {
    verticalAlign: 'sub',
    fontSize: 'smaller',
  },
}));

// Simple example
const findChunks = ({ textToHighlight }) => {
  const chunks = [];
  const textLow = textToHighlight.toLowerCase();
  // Match at the beginning of each new word
  // New word start after whitespace or - (hyphen)
  const sep = /[-\s]+/;

  // Match at the beginning of each new word
  // New word start after whitespace or - (hyphen)
  const singleTextWords = textLow.split(sep);

  // It could be possible that there are multiple spaces between words
  // Hence we store the index (position) of each single word with textToHighlight
  let fromIndex = 0;
  const singleTextWordsWithPos = singleTextWords.map(s => {
    const indexInWord = textLow.indexOf(s, fromIndex);
    fromIndex = indexInWord;
    return {
      word: s,
      index: indexInWord,
    };
  });

  // Add chunks for every searchWord
  lookups.forEach(l => {
    const swLow = l.lookup.toLowerCase();
    // Do it for every single text word
    singleTextWordsWithPos.forEach(s => {
      if (s.word.includes(swLow)) {
        const { start, end } = l.getRange(s);
        chunks.push({
          start,
          end,
        });
      }
    });
  });

  return chunks;
};

const PlusHighlighter = props => {
  const classes = useStyles();
  return (
    <Highlighter
      autoEscape={false}
      searchWords={[]}
      highlightClassName={{
        plus: classes.italic,
        '2': classes.superScript,
      }}
      highlightTag="span"
      findChunks={findChunks}
      {...props}
    />
  );
};

export default PlusHighlighter;
